export default {
  familyName: 'Nunito Sans',
  fullName: 'Nunito Sans 12pt SemiBold',
  postscriptName: 'NunitoSans12pt-SemiBold',
  category: 'sans-serif',
  capHeight: 705,
  ascent: 1011,
  descent: -353,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 488,
  xWidthAvg: 460,
  subsets: {
    latin: {
      xWidthAvg: 460
    },
    thai: {
      xWidthAvg: 500
    }
  }
};
